module.exports = __webpack_public_path__ + "img/pdf.2939ee05.png";